import React, { useState } from "react";
// import "./ProfilePhoto.css"; // You'll need to create this CSS file

function UserPremiumExperience() {
  const [photos, setPhotos] = useState([
    {
      src: "https://images.pexels.com/photos/674010/pexels-photo-674010.jpeg?auto=compress&cs=tinysrgb&w=600",
      isProfile: true,
    },
    {
      src: "https://images.pexels.com/photos/757889/pexels-photo-757889.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      src: "https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
  ]);

  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [showOptions, setShowOptions] = useState(null);
  const [showDialogOptions, setShowDialogOptions] = useState(false);
//   const fetchPhotos = async () => {
//     const response = await getPhotos({ 'tokan': token });
//     if (response.status === 200 || response.status === 201) {
//         setApprovedPhotos(response.data.data.approved_photos || {});
//         setDefaultPhoto(response.data.data.default_photo || []);
//         setNonApprovedPhotos(response.data.data.nonapprovedphoto || {});
//     }
// };
// fetchPhotos();
  const handleProfilePhoto = (id) => {
    setPhotos((prevPhotos) =>
      prevPhotos.map((photo) => ({
        ...photo,
        isProfile: photo.id === id,
      }))
    );
    setShowOptions(null);
    setShowDialogOptions(false);
  };

  const handlePhotoClick = (photo) => {
    setSelectedPhoto(photo);
    setShowDialog(true);
  };

  const handleDeletePhoto = (id) => {
    setPhotos((prevPhotos) => prevPhotos.filter((photo) => photo.id !== id));
    setShowDialog(false);
    setShowOptions(null);
    setShowDialogOptions(false);
  };

  const handleOptionsClick = (e, id) => {
    e.stopPropagation();
    setShowOptions(showOptions === id ? null : id);
  };

  return (
    <div className="col-lg-9 col-12">
      <div className="header">
        <button className="back-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <h1>Profile Photos</h1>
      </div>

      <div className="photo-grid">
        {photos.map((photo) => (
          <div
            key={photo.id}
            className="photo-container"
            onClick={() => handlePhotoClick(photo)}
          >
            <img src={photo.src} alt="Profile" />
            {photo.isProfile && <span className="profile-badge">Profile Photo</span>}
            {!photo.isProfile && (
              <div className="options-container">
                <button
                  className="options-button"
                  onClick={(e) => handleOptionsClick(e, photo.id)}
                >
                  ⋮
                </button>
                {showOptions === photo.id && (
                  <div className="options-menu">
                    <button onClick={() => handleProfilePhoto(photo.id)}>
                      Make Profile Photo
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {showDialog && selectedPhoto && (
        <div className="dialog-overlay" onClick={() => setShowDialog(false)}>
          <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
            <div className="dialog-header">
              <div className="dialog-options">
                <button
                  className="options-button"
                  onClick={() => setShowDialogOptions(!showDialogOptions)}
                >
                  ⋮
                </button>
                {showDialogOptions && (
                  <div className="options-menu dialog-options-menu">
                    <button onClick={() => handleProfilePhoto(selectedPhoto.id)}>
                      Make Profile Photo
                    </button>
                    <button onClick={() => handleDeletePhoto(selectedPhoto.id)}>
                      Delete Photo
                    </button>
                  </div>
                )}
              </div>
              <button
                className="close-button"
                onClick={() => setShowDialog(false)}
              >
                ✕
              </button>
            </div>
            <img src={selectedPhoto.src} alt="Selected" />
          </div>
        </div>
      )}
    </div>
  );
}

export default UserPremiumExperience;